import { inject } from 'vue';

export function install(app, args = {}) {
  if (args?.dialogStack?.injectionKey) {
    app.config.globalProperties.$injectDialogStack = () => {
      return inject(args.dialogStack.injectionKey, null)
    };
  }

  registerComponents(app, args.components || {});
}

const registerComponents = (app, components) => {
  if (components) {
    for (const key in components) {
      const component = components[key];
      if (component) {
        app.component(key, component);
      }
    }
    return true;
  }
  return false;
};
